var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09746 0.333435L0.666016 7.02474L2.89645 9.50189L10.3279 2.81059L8.09746 0.333435Z",
    fill: "#CC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 10.3334H20.666V17.0001H25.666V20.3334H17.3327V10.3334Z",
    fill: "#CC0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99935 17.0001C3.99935 8.71583 10.7151 2.0001 18.9993 2.0001C27.2836 2.0001 33.9993 8.71583 33.9993 17.0001C33.9993 25.2844 27.2836 32.0001 18.9993 32.0001C10.7151 32.0001 3.99935 25.2844 3.99935 17.0001ZM7.33268 17.0001C7.33268 10.5568 12.556 5.33344 18.9993 5.33344C25.4427 5.33344 30.666 10.5568 30.666 17.0001C30.666 23.4434 25.4427 28.6668 18.9993 28.6668C12.556 28.6668 7.33268 23.4434 7.33268 17.0001Z",
    fill: "#CC0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9012 0.333435L37.3327 7.02474L35.1022 9.50189L27.6708 2.81059L29.9012 0.333435Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.9ae644c7.svg";
export { ForwardRef as ReactComponent };